Platform.Deferred.execute(setViewDetailsScript);
var canBeGiftWrapped = "@Model.data.CanBeGiftWrapped";
var stockNotifyProdId;
var stockNotifyIsVariant = "False";
var stockNotifyLoggedIn = "False";
var stockNotifyEmail = "";
var hasVariants;
var showStockCount;

function setViewDetailsScript() {

    hasVariants = $('#pf-product-details-page').data('has-variants') === 'True';
    showStockCount = $('#pf-product-details-page').data('show-stock-count') === 'True';
    hideStockNumbers = $('#pf-product-details-page').data('hide-stock-numbers') === 'True';

    //Control RelatedProducts
    var relatedDiv = document.getElementById('RelatedRecentlyProducts');
    if (relatedDiv !== null) {

        var prodId = $(relatedDiv).data("prod-id");
        $('#RelatedRecentlyProducts').load(root + "Products/RelatedRecentlyProducts?prodID=" + prodId, function () {
            $('#RelatedRecentlyProducts').hide().fadeIn('slow');
        });
    }



    // stock notify handler
    var stockModal = $('[data-remodal-id=stock-notify-modal]').remodal();
    $('.pf-stock-notify-me-btn').click(function () {
        stockNotifyProdId = $(this).data("prod-id");
        stockNotifyIsVariant = $(this).data("is-variant");
        stockNotifyLoggedIn = $(this).data("user-logged-in");
        if (stockNotifyLoggedIn == "False") {
            stockModal.open();
        }
        else {
            RegisterStockNotify();
        }
    });

    $('#register-stock-notify-form').submit(function (e) {
        e.preventDefault();
        stockNotifyEmail = $('#stock-notify-email').val();
        RegisterStockNotify();
    });



    function RegisterStockNotify() {

        $.ajax({
            url: root + "UserAccount/RegisterStockNotify",
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                prodId: stockNotifyProdId,
                isVariant: stockNotifyIsVariant,
                email: stockNotifyEmail
            }),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                if (data.result == "ok") {
                    if (stockNotifyLoggedIn) {
                        $('#stock-notify-content').hide();
                        $('#stock-notify-rsp').show();
                        stockModal.open();
                    }
                    else {
                        $('#stock-notify-content').fadeOut(function () {
                            $('#stock-notify-rsp').fadeIn();
                        });
                    }
                }
                else {
                    alert('Sorry there was a problem processing your request.');
                }
            },
            error: function () {
                alert('Sorry there was a problem processing your request.');
            }
        });
    }


    //handle selecting variants from dropdown
    showSelectedVariant();
    //$(".pf-qty-btn-plus").unbind("click");
    //$(".pf-qty-btn-plus").click(function () {
    //    var $this = $(this);
    //    var quantity = parseInt($this.siblings(".qty-tbx").val()) + 1;
    //    $(this).siblings(".qty-tbx").val(quantity);
    //});
    //$(".pf-qty-btn-minus").unbind("click");
    //$(".pf-qty-btn-minus").click(function () {
    //    var $this = $(this);
    //    var quantity = parseInt($this.siblings(".qty-tbx").val()) - 1;
    //    if (quantity <= 0) {
    //        quantity = 1;
    //    }
    //    $(this).siblings(".qty-tbx").val(quantity);
    //});
    $('#variant-select').on('change', function () {
        showSelectedVariant();
    });
    function showSelectedVariant() {
        $(".variantRow").hide(50, function () {
            $(".current").removeClass("current");
            var selected = $("#variant-select").find(":selected");
            var selectedID = $(selected).val();
            var selectorString = "#variant-row-" + selectedID;
            $(selectorString).show(50);
            $(selectorString).addClass("current");
        });
    }
    $('.productwrapper').matchHeight();

    $('#other-products-tabs a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });

    $('#product-media-holder').lightGallery({
        selector: '.product-media',
        loadYoutubeThumbnail: false,
        loadVimeoThumbnail: false
    });

    $('#product-media-holder-2').lightGallery({
        selector: '.mobile-vid',
        loadYoutubeThumbnail: false,
        loadVimeoThumbnail: false
    });

    $('.pf-detail-view-add-cart-wrapper .pf-qty-btn-minus').click(function () {
        var wrapper = $(this).closest('.pf-qty-wrapper');
        var qtyTbx = wrapper.find('.pf-qty-select');
        var qty = Number(qtyTbx.val());
        var uom = qtyTbx.data('uom');
        var min = qtyTbx.data('min');
      
        var minQty = min;
        if (minQty % uom !== 0)
            minQty = minQty - (minQty % uom) + uom;

        if (qty > uom)
            qty -= uom;

        if (minQty > 1 && qty < minQty) {
            qty = minQty;
            Lobibox.notify('warning', {
                msg: 'This product has a minimum order quantity of ' + minQty,
                icon: 'fas fa-info-circle',
                title: 'Minimum Order Quantity'
            });
        }
        qtyTbx.val(qty);
    });

    $('.pf-detail-view-add-cart-wrapper .pf-qty-btn-plus').click(function () {
        var wrapper = $(this).closest('.pf-qty-wrapper');
        var qtyTbx = wrapper.find('.pf-qty-select');
        var qty = Number(qtyTbx.val());
        var uom = qtyTbx.data('uom');
        qty += uom;
        qtyTbx.val(qty);
    });

    // main call to add a product to the cart
    $('.pf-add-to-cart-btn').click(function () {
        var fbPixelEnabled = $('#pf-product-details-page').data("fb-pixel");
        var limitToStock = $('#pf-product-details-page').data('limit-to-stock') === 'True';
        var personalisationRequired = $('#pf-product-details-page').data('product-personalisation-required') ==='True';
        var btn = $(this);
        var id = btn.data("id");
        var wrapper = btn.closest('.pf-detail-view-add-cart-wrapper');
        var qty = wrapper.find('.pf-qty-select').val();
        var optionsAdv;

        // check if this is a product with components, if so check all have been selected
        var hasComponents = $('#pf-product-details-page').data('product-has-components') === 'True';
        if (hasComponents) {
            $('.pf-product-component-select-wrapper').removeClass('validation-error');
            // check all selected otherwise cannot add to cart
            if (!CheckComponentsSelected()) {
                SetPlatformModalContent("Warning", "Please select from the available product options");
                OpenPlatformModal("650px");
                $('.pf-product-component-select-wrapper').addClass('validation-error');
                return false;
            }

            // if product purchase is limited to available stock then check qty against current stock
            if (limitToStock) {
                var currentStock = parseInt($('#pf-calculated-stock').text());
                var qtyCheck = parseInt(qty);
                if (qtyCheck > currentStock) {
                    SetPlatformModalContent("Warning", "Sorry there are " + currentStock + " of this combination currently in stock");
                    OpenPlatformModal("650px");
                    return false;
                }
            }

            // if all selected then setup the object to pass into the cart
            optionsAdv = GetSelectedOptionsAdv();
        }

        var prodOptsOk = true;
        $('.productOptions').each(function () {
            if ($(this).length > 0) {
                if ($(this).val() == 0) {
                    $(this).next('.productOptionWarn').fadeIn();
                    $(this).addClass("highlight");
                    prodOptsOk = false;
                    return false;
                }
            }
        });

        if (prodOptsOk == false) {
            return false;
        }

        var opts = [];
        $('.productOptions').each(function (i, o) {
            var opt = {};
            var name = $(this).attr('id');
            name = name.replace("option-select-", "");
            opt.index = i;
            opt.name = name;
            opt.value = $(this).val();
            opts.push(opt);
        });


        var parentID = $('#parent-id').val();
        var catID = $('#cat-id').val();
        var listby = $('#listby').val();
        var size = $('#size-select').val();
        var personalizeText = $('#PersonalizeProductText').val();


        // gift option and message
        var useGiftBox = false;
        if (canBeGiftWrapped == "True") {
            $('#giftBoxingCbx').prop('checked');
            useGiftBox = true;
        }
        if (useGiftBox) {
            var personalMessage = $('#giftBoxText').val();
        }

        var variantId = $(btn).data("variant-id");

        if (variantId != 0) {
            qty = $(this).closest(".variant-table").find('.qty-tbx').val();
        }
        //check if personalisation it is required
        if (personalisationRequired)
        {
            if (!$('#PersonalizeProductText').val())
            {
                $('#PersonalizeProductText').addClass('validity-erroneous');
                alert('Please personalise the product before adding it to the cart.');
                return false;
            }
        }
        $.ajax({
            url: root + "Cart/AddToCart",
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                productId: id,
                variantId: variantId === 0 ? null : variantId,
                quantity: qty,
                options: opts,
                optionsAdv: optionsAdv,
                personalizeText: personalizeText
            }),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                //AddedToCart(data);
                $(document).trigger('itemAdded.product.platform', data);
                //SetCartQty();
                if (fbPixelEnabled == "True") {
                    fbq_addToBag();
                }
            }
        });

        return false;
    });

    $('#size-select').change(function () {
        $('#choose-size-warn').fadeOut();
    });

    $('.productOptions').change(function () {
        $(this).removeClass('highlight');
        $(this).next('.productOptionWarn').fadeOut();
    });

   

    // group products
    $(".pf-product-group-wrapper").on({
        mouseenter: function () {
            var swapIn = $(this).data("image-url");
            var mainImgContainer = $('.pf-product-main-image-wrapper').find('img');
            var mainImage = mainImgContainer.prop('src');
            $(this).data("orig-img-url", mainImage);
            mainImgContainer.prop('src', swapIn);
        },
        mouseleave: function () {
            var swapIn = $(this).data("orig-img-url");
            var mainImgContainer = $('.pf-product-main-image-wrapper').find('img');
            mainImgContainer.prop('src', swapIn);
        },
        click: function () {
            // Handle click...
        }
    }, ".pf-group-prod");

    // accordion for component products
    var acc = document.getElementsByClassName("pf-product-component-accordion");
    var i;
    // attach listener to each accordion header
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("pf-product-component-accordion-active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    // init advanced options in case they are pre-selected
    var componentPriceType = $('#pf-product-details-page').data("product-component-price-type");
    if (CheckComponentsSelected() === true) {
        console.log("Component product all options selected");
        var optionsAdv = GetSelectedOptionsAdv();
        if (componentPriceType === 'BASE_PLUS_OPTIONS') {
            GetCalculatedPrice(optionsAdv);
            SetFavButtons(optionsAdv);
            if (showStockCount)
                GetCalculatedStock(optionsAdv);
        }
    }


    $(document).on('click', '.pf-product-component-select', function (e) {
        //e.preventDefault();
        var obj = $(this);
        var id = obj.data("id");
        var title = obj.data("name");
        var componentSelector = obj.closest('.pf-product-component-accordion-panel');
        var selectorHead = componentSelector.prev();
        var selectedText = selectorHead.find('.pf-component-select-text > u');
        selectedText.text(title);
        selectorHead.data("selected-id", id);
        selectorHead.data("selected-name", title);
        // slide panel up
        componentSelector.css('max-height', '');
        selectorHead.removeClass("pf-product-component-accordion-active");

        // set border on selected option
        // find all options in this set and remove selected class
        componentSelector.each(function () {
            $(this).find('.pf-product-component-select').removeClass('pf-product-component-selected');
        });
        // add selected to this item
        obj.addClass('pf-product-component-selected');

        // check if we need to calculate price, and if all options are selected then we can get the price from backend
        //var componentPriceType = $('#pf-product-details-page').data("product-component-price-type");
        //{
            if (CheckComponentsSelected() === true) {
                console.log("Component product all options selected");
                var optionsAdv = GetSelectedOptionsAdv();
                if (componentPriceType === 'FIXED_PRICE') {
                    SetFavButtons(optionsAdv);
                    if (showStockCount)
                        GetCalculatedStock(optionsAdv);
                }
                else if (componentPriceType === 'BASE_PLUS_OPTIONS' || componentPriceType === 'HIGHEST_OPTION_PRICE') {
                    GetCalculatedPrice(optionsAdv);
                    SetFavButtons(optionsAdv);
                    if (showStockCount)
                        GetCalculatedStock(optionsAdv);
                }
            }
        //}
    });
    //Variant Grid
    $(document).on('click', '.pf-product-details-variant-grid', function (e) {
        //e.preventDefault();
        var obj = $(this);
        var id = obj.data("id");
        $('.variantGrid').hide(50);
        //var title = obj.data("name");
        var variantWrapper = obj.closest('.pf-product-details-variant-grid-wrapper');

        // find all variants in this set and remove selected class
        variantWrapper.each(function () {
            $(this).find('.pf-product-details-variant-grid').removeClass('pf-product-details-variant-grid-selected');
        });
        // add selected to this item
        obj.addClass('pf-product-details-variant-grid-selected');
        //var selectorString = "#variant-grid-actions-" + id;
        $("#variant-grid-actions-" + id).show(50);
    });
}

function openTab(evt, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("w-tab-pane");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("w-tab-link");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" w--current", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " w--current";
}

// checks if all all components of a product with component options have been selected true if they have, false if not
function CheckComponentsSelected() {
    if ($('#pf-product-details-page').data('product-has-components') === "True") {
        // check all have been selected
        var allSelected = true;
        $('.pf-product-component-select-data').each(function () {
            var selectedId = $(this).data('selected-id');
            if (selectedId === undefined) {
                allSelected = false;
            }
        });
        return allSelected;
    }
}


// gets an object with all the currently selected components
function GetSelectedOptionsAdv() {
    var optionsAdv = [];
    $('.pf-product-component-select-data').each(function (i, o) {
        var $this = $(this);
        var selectedId = $this.data('selected-id');
        if (selectedId !== undefined) {
            optionsAdv.push({
                groupId: $this.data('component-group-id'),
                groupName: $this.data('component-name'),
                optionProductId: selectedId,
                optionProductName: $this.data('selected-name')
            });
        }
    });
    return optionsAdv;
}

function GetCalculatedPrice(optionsAdv) {
    if (hasVariants) {
        // get product related prices (discounts etc? - do these work with variants???)

        // loop each variant and get its calculated price
        $('.pf-product-variant-item').each(function () {
            var variantId = $(this).data("variant-id");
            var productId = $(this).data("product-id");
            $.post(root + "Products/GetPriceOptionsAdv", {
                productId: productId,
                optionsAdv: optionsAdv,
                variantId: variantId,
                isVariant: true
            }, function (data) {
                // find the variant container and set the data for it
                    if (data.result === 0) {

                        $('.pf-product-variant-item[data-variant-id="' + data.variantId + '"] span[itemprop=price]').text((data.showSalePrice ? data.salePriceString : data.priceString )+ ' ' + data.priceLabel);
                        $('.pf-product-variant-item[data-variant-id="' + data.variantId + '"] span.pf-price-old').text(data.showSalePrice ? data.priceString : '' );
                        if (data.showSalePrice) {
                            $('.pf-product-variant-item[data-variant-id="' + data.variantId + '"] span.pf-price-old').removeClass("pf-hide");
                        }

                    var $priceWrapper = $('.pf-product-variant-item[data-variant-id="' + data.variantId + '"]');
                    var $discTable = $priceWrapper.find('.pf-disc-table');
                    if (data.quantityPriceListPrices.length > 0) {
                        if ($discTable.length === 0) {
                            $discTable = $('<table class="pf-disc-table">').append($('<tbody>'));
                            $priceWrapper.append($discTable);
                        } else {
                            $discTable.find('tbody').empty();
                        }

                        var $discTableTbody = $discTable.find('tbody');
                        $.each(data.quantityPriceListPrices, function () {
                            var $discTableTd = $('<td>').append(document.createTextNode('Buy ' + this.quantityBreak + ' for '));
                            if (this.showSalePrice)
                                $discTableTd.append($('<strike>').text(this.priceString)).append(document.createTextNode(' ' + this.salePriceString + ' each'));
                            else
                                $discTableTd.append(document.createTextNode(this.priceString + ' each'));
                            var $discTableTr = $('<tr>').append($discTableTd);
                            $discTableTbody.append($discTableTr);
                        });
                    } else {
                        if ($discTable.length > 0) $discTable.remove();
                    }
                } else {
                    alert("Error: " + data.error);
                }
            }, "json");
        });
    }
    else {
        $.post(root + "Products/GetPriceOptionsAdv", {
            productId: $('#pf-product-details-page').data('product-id'),
            optionsAdv: optionsAdv
        }, function (data) {
            if (data.result === 0) {

                $('.product-detail-price span[itemprop=price]').text((data.showSalePrice ? data.salePriceString : data.priceString) + " " + data.priceLabel);
                $('.product-detail-price span.pf-price-old').text(data.showSalePrice ? data.priceString : '');

                var $priceWrapper = $('.pf-product-details-price-wrapper');
                var $discTable = $priceWrapper.find('.pf-disc-table');
                if (data.quantityPriceListPrices.length > 0) {
                    if ($discTable.length === 0) {
                        $discTable = $('<table class="pf-disc-table">').append($('<tbody>'));
                        $priceWrapper.append($discTable);
                    } else {
                        $discTable.find('tbody').empty();
                    }

                    var $discTableTbody = $discTable.find('tbody');
                    $.each(data.quantityPriceListPrices, function () {
                        var $discTableTd = $('<td>').append(document.createTextNode('Buy ' + this.quantityBreak + ' for '));
                        if (this.showSalePrice)
                            $discTableTd.append($('<strike>').text(this.priceString)).append(document.createTextNode(' ' + this.salePriceString + ' each'));
                        else
                            $discTableTd.append(document.createTextNode(this.priceString + ' each'));
                        var $discTableTr = $('<tr>').append($discTableTd);
                        $discTableTbody.append($discTableTr);
                    });
                } else {
                    if ($discTable.length > 0) $discTable.remove();
                }
            } else {
                alert("Error: " + data.error);
            }
        }, "json");
    }
}

function GetCalculatedStock(optionsAdv) {
    if (hasVariants) {
       // loop each variant and get its calculated price
        $('.pf-product-variant-item').each(function () {
            var variantId = $(this).data("variant-id");
            var productId = $(this).data("product-id");
            $.post(root + "Products/GetStockOptionsAdv", {
                productId: productId,
                optionsAdv: optionsAdv,
                variantId: variantId,
                isVariant: true
            }, function (data) {
                // find the variant container and set the data for it
                if (data.result === 0) {
                    var $variantWrapper = $('.pf-product-variant-item[data-variant-id="' + data.variantId + '"]');
                    var $variantStockInfo = $variantWrapper.find('.pf-stock-info');
                    var $variantStockSummary = $variantStockInfo.find('.pf-stock-summary');
                    var stockSummaryHtml = '';
                    if (data.isInStock) {
                        $variantStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-available');
                        if (hideStockNumbers)
                            stockSummaryHtml += 'In stock';
                        else
                            stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.stock + '</span> in stock';
                    } else if (data.isOnBackorder) {


                        $variantStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-backorder');
                        stockSummaryHtml += '<i class="fas fa-clock"></i> ';
                        if (data.backorderedMessage === "") {
                            if (hideStockNumbers)
                                stockSummaryHtml += data.backorderDueString !== null ? 'Due in ' + data.backorderDueString : 'On backorder';
                            else
                                stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.stockBackordered + '</span> ' + (data.backorderDueString !== null ? 'due in ' + data.backorderDueString : 'on backorder');
                        }
                        else {
                            stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.backorderedMessage + '</span>';
                        }
                    } else {
                        $variantStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-unavailable');
                        stockSummaryHtml += '<i class="fas fa-exclamation-circle"></i> Out of stock';
                    }
                    $variantStockSummary.html(stockSummaryHtml);
                    $variantStockInfo.removeClass('pf-hide');
                } else {
                    alert("Error: " + data.error);
                }
            }, "json");
        });
    } else {
        $.post(root + "Products/GetStockOptionsAdv", {
            productId: $('#pf-product-details-page').data('product-id'),
            optionsAdv: optionsAdv
        }, function (data) {
            if (data.result === 0) {
                var $productStockInfo = $('#product-stock-info');
                var $productStockSummary = $productStockInfo.find('.pf-stock-summary');
                var stockSummaryHtml = '';
                if (data.isInStock) {
                    $productStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-available');
                    if (hideStockNumbers)
                        stockSummaryHtml += 'In stock';
                    else
                        stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.stock + '</span> in stock';
                } else if (data.isOnBackorder) {
                    $productStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-backorder');
                    stockSummaryHtml += '<i class="fas fa-clock"></i> ';
                    if (data.backorderedMessage === "") {
                        if (hideStockNumbers)
                            stockSummaryHtml += data.backorderDueString !== null ? 'Due in ' + data.backorderDueString : 'On backorder';
                        else
                            stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.stockBackordered + '</span> ' + (data.backorderDueString !== null ? 'due in ' + data.backorderDueString : 'on backorder');
                    }
                    else {
                        stockSummaryHtml += '<span class="stock-count pf-stock-count">' + data.backorderedMessage + '</span>';
                    }
                } else {
                    $productStockSummary.attr('class', 'pf-stock-summary pf-stock-summary-unavailable');
                    stockSummaryHtml += '<i class="fas fa-exclamation-circle"></i> Out of stock';
                }
                $productStockSummary.html(stockSummaryHtml);
                $productStockInfo.removeClass('pf-hide');
            } else {
                alert("Error: " + data.error);
            }
        }, "json");
    }
}



//function AddedToCart(data) {
//    if (data.result == "ok") {
//        GetAndOpenTopCart();
//        $("html, body").animate({ scrollTop: 0 }, "slow"); // scroll to top
//    }
//    if (data.result == "ok-stock-limited") {
//        alert("Sorry there are only " + data.qty + " of these items available in stock.");
//        GetAndOpenTopCart();
//        $("html, body").animate({ scrollTop: 0 }, "slow"); // scroll to top
//    }
//    if (data.result == "ok-out-of-stock") {
//        alert("Sorry this item is no longer in stock.");
//        GetTopCart();
//    }
//}

function vidClosed() {
    jQuery("#youtubePlayerContainer").tubeplayer("stop");
}
